/**
 * Session Resource Client
 * Handles authentication and session management
 */

import { ApiClient } from './apiClient';

export interface RequestCodeResponse {
  success: boolean;
  error?: string;
}

export interface VerifyCodeResponse {
  success: boolean;
  token?: string;
  sessionId?: string;
  error?: string;
}

export class SessionResource {
  constructor(private apiClient: ApiClient) { }

  /**
   * Request verification code for email
   */
  async requestCode(email: string, storeId: string): Promise<RequestCodeResponse> {
    try {
      await this.apiClient.post(
        '/api/v1/cms/session/request-code',
        {
          email,
          storeId,
        }
      );

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to send code',
      };
    }
  }

  /**
   * Verify code and login
   */
  async verifyCode(
    email: string,
    code: string,
    storeId: string
  ): Promise<VerifyCodeResponse> {
    try {
      const response = await this.apiClient.post<{ token: string; sessionId: string }>(
        '/api/v1/cms/session/login',
        {
          email,
          code,
          storeId,
        }
      );

      if (!response) {
        return {
          success: false,
          error: 'Invalid code',
        };
      }

      return {
        success: true,
        token: response.token,
        sessionId: response.sessionId,
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to verify code',
      };
    }
  }
}

